import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody } from '@/api/types';
import { getRegionsApiUrl } from './regions.paths';
import { PaginatedRegionListFilters, PatchRegionRequestBody, RegionType, ServiceRegionType } from './regions.types';

const getRegionsList = async (params: PaginatedRegionListFilters) => {
  const res = await http.get<ApiResponseBody<RegionType[]>>(getRegionsApiUrl.list(), { params });
  return res.data.data;
};

const getRegionsListV2 = async (params: PaginatedRegionListFilters) => {
  const res = await http.get<PaginatedApiResponseBody<RegionType>>(getRegionsApiUrl.listV2(), { params });
  return res.data.data;
};

const getRegionById = async (regionId: string) => {
  const res = await http.get<ApiResponseBody<RegionType>>(getRegionsApiUrl.regionById(regionId));
  return res.data.data;
};

const updateRegionById = async (regionId: string, body: PatchRegionRequestBody) => {
  const res = await http.patch<ApiResponseBody<RegionType>>(getRegionsApiUrl.regionById(regionId), body);
  return res.data.data;
};

const getServiceRegionsList = async () => {
  const res = await http.get<ApiResponseBody<ServiceRegionType[]>>(getRegionsApiUrl.serviceRegions());
  return res.data.data;
};

export const regionsApiFetcher = {
  /**
   * @deprecated
   */
  getRegionsList,
  getRegionsListV2,
  getRegionById,
  updateRegionById,
  getServiceRegionsList,
};
